import { addListStyles } from "@collectivehealth/dls-dropdowns";
import styles from "./list.css";
import horizontalLayoutStyles from "./horizontalList.css";

addListStyles([
  {
    attributeName: "theme",
    attributeValue: "no-indentation",
    className: "ignore",
    styles: styles.toString(),
    parts: {
      listItemContent: styles.locals.listItemContent
    }
  },
  {
    attributeName: "theme",
    attributeValue: "horizontal-layout",
    className: "ignore",
    styles: horizontalLayoutStyles.toString(),
    parts: {
      list: horizontalLayoutStyles.locals.list,
      listItem: horizontalLayoutStyles.locals.listItem,
      listItemContent: horizontalLayoutStyles.locals.listItemContent
    }
  }
]);
